/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectInvoiceResource
 */
export interface ProjectInvoiceResource {
    /**
     * 
     * @type {string}
     * @memberof ProjectInvoiceResource
     */
    type: ProjectInvoiceResourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvoiceResource
     */
    invoiceId: string;
    /**
     * 
     * @type {Date}
     * @memberof ProjectInvoiceResource
     */
    issueDate: Date;
    /**
     * expense batch number, year month or generic project name depending on type
     * @type {string}
     * @memberof ProjectInvoiceResource
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectInvoiceResource
     */
    totalAmount: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvoiceResource
     */
    paymentStatus: ProjectInvoiceResourcePaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectInvoiceResource
     */
    lotId?: string;
}


/**
 * @export
 */
export const ProjectInvoiceResourceTypeEnum = {
    ProjectInvoice: 'PROJECT_INVOICE',
    ProjectLotInvoice: 'PROJECT_LOT_INVOICE',
    ExpenseInvoice: 'EXPENSE_INVOICE'
} as const;
export type ProjectInvoiceResourceTypeEnum = typeof ProjectInvoiceResourceTypeEnum[keyof typeof ProjectInvoiceResourceTypeEnum];

/**
 * @export
 */
export const ProjectInvoiceResourcePaymentStatusEnum = {
    Pending: 'PENDING',
    Overdue: 'OVERDUE',
    Done: 'DONE'
} as const;
export type ProjectInvoiceResourcePaymentStatusEnum = typeof ProjectInvoiceResourcePaymentStatusEnum[keyof typeof ProjectInvoiceResourcePaymentStatusEnum];


/**
 * Check if a given object implements the ProjectInvoiceResource interface.
 */
export function instanceOfProjectInvoiceResource(value: object): value is ProjectInvoiceResource {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    if (!('issueDate' in value) || value['issueDate'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    return true;
}

export function ProjectInvoiceResourceFromJSON(json: any): ProjectInvoiceResource {
    return ProjectInvoiceResourceFromJSONTyped(json, false);
}

export function ProjectInvoiceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectInvoiceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'invoiceId': json['invoiceId'],
        'issueDate': (new Date(json['issueDate'])),
        'name': json['name'],
        'totalAmount': json['totalAmount'],
        'paymentStatus': json['paymentStatus'],
        'lotId': json['lotId'] == null ? undefined : json['lotId'],
    };
}

export function ProjectInvoiceResourceToJSON(value?: ProjectInvoiceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'invoiceId': value['invoiceId'],
        'issueDate': ((value['issueDate']).toISOString()),
        'name': value['name'],
        'totalAmount': value['totalAmount'],
        'paymentStatus': value['paymentStatus'],
        'lotId': value['lotId'],
    };
}

